import { render, staticRenderFns } from "./open.vue?vue&type=template&id=0e70df01&scoped=true&lang=true&"
import script from "./open.vue?vue&type=script&lang=js&"
export * from "./open.vue?vue&type=script&lang=js&"
import style0 from "./open.vue?vue&type=style&index=0&id=0e70df01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e70df01",
  null
  
)

export default component.exports